import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const RedirectToMYOB = () => {
  useEffect(() => {
    window.location.href = "https://myobtoxero.onrender.com"; // Redirect to the external link
  }, []);

  return <p>Redirecting to MYOB to Xero...</p>; // Show a message while redirecting
};


